import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import ActivateAccount from "../components/activateAccout";

function ActivatePage() {
  return (
    <>
      <Navbar />
      <ActivateAccount />
      <Footer />
    </>
  );
}

export default ActivatePage;
